<template>
  <div style="height: 100vh; width: 100%; background: #f4f6fa">
    <pcHeaders></pcHeaders>
    <div class="banner">
      <div class="subBox">
        <div class="subTitle">
          <div class="s1" @click="goBack">返回列表</div>
          <div class="s2">学习报名</div>
          <div class="s3">* 为必填选项</div>
        </div>

        <div class="formBox">
          <el-form :model="form" label-position="left" :rules="rules" ref="ruleForm" label-width="135px" class="demo-ruleForm">
            <el-row>
              <el-form-item label="培训工种：">
                <el-input style="width: 210px" v-model="form.codeName" disabled></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="培训科目：" prop="projectId">
                  <el-cascader
                    ref="projectCascader"
                    v-model="form.projectId"
                    :options="subjectList"
                    @change="handlChange"
                    :props="{ value: 'cid', label: 'codeName' }"
                    placeholder="请选择培训科目"
                  >
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" v-for="item in textList" :key="item.id">
                <el-form-item :label="`${item.fieldName}：`" :prop="item.id" :required="item.isRequired === '01'">
                  <el-input @input="handLand" style="width: 210px" v-model="form[item.id]" :placeholder="item.placeholder == null ? `请输入${item.fieldName}` : item.placeholder" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div style="display: flex; flex-wrap: wrap; margin-top: 40px">
                  <div class="up" style="" v-for="item in imgList" :key="item.id">
                    <div><span style="color: #f56c6c; margin-right: 4px" v-if="item.isRequired == '01'">*</span>{{ item.fieldName }}</div>
                    <div class="c1" :key="keyFag1" style="display: flex; justify-content: center; align-items: center">
                      <img v-if="item.imgUrl == '' || !item.imgUrl" src="../../assets/listImgs/cearm.png" alt="" :key="imgKey" />
                      <el-image :preview-src-list="[item.imgUrl]" class="allImage" v-else :src="item.imgUrl" alt="" />
                    </div>
                    <div style="width: 237px; display: flex; justify-content: center">
                      <div>
                        <el-upload
                          class="upload-demo"
                          :action="uploadUrl"
                          :show-file-list="false"
                          :on-success="(response, file, fileList) => handleAvatarSuccessALL(response, file, fileList, item)"
                          :before-upload="beforeAvatarUpload"
                          :headers="headers"
                        >
                          <el-button class="upBtn">上传照片</el-button>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>

          <div class="xu" style="padding-top: 40px"></div>
          <!-- <div class="updataBox">
            <div>
              <div class="up">
                <div><span style="color: #f56c6c; margin-right: 4px">*</span>选择线下实训班</div>
                <div class="sxbBox">
                  <div
                    :class="s1Tab == index ? 's1 yActive' : 's1'"
                    v-for="(item, index) in configVos"
                    :key="item.configId"
                    @click="handlForm(item, index)"
                  >
                    <div class="yuan" v-if="s1Tab == index">
                      <img src="../../assets/listImgs/seleted.png" alt="" />
                    </div>
                    <div class="noYuan" v-else></div>
                    <div class="s2">
                      <div>
                        <span class="s3">培训班名称：</span>{{ item.offlineClassName == null ? '暂无名称' : item.offlineClassName }}
                      </div>
                      <div style="margin-top: 12px">
                        <span class="s3">培训费用：</span><span style="color: #ff0000">{{ item.price }}元</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="xu" style="padding-top: 40px"></div> -->
          <div style="margin-top: 20px; font-size: 16px">
            温馨提示：持有学习卡的学员，在支付页面选中学习卡后输入对应账号和卡密进行购课。(点击提交报名进入支付页面)
          </div>
          <div class="subBtn" @click="submitForm">提交报名</div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { getEducationList, codeListByParent, getClassListBySubject, toGenerateOrder } from '@/api/courseSelection.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      form: {
        sysEnrollmentUserApplyVos: {}
      },
      pickerOptions: {
        disabledDate: time => {
          // 获取当前日期
          const currentDate = new Date();
          // 获取当前年份和月份
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth();
          // 获取选择器传入的日期
          const timeYear = time.getFullYear();
          const timeMonth = time.getMonth();

          // 禁用之前的月份
          // 如果年份小于当前年份，则禁用
          // 如果年份等于当前年份但月份小于当前月份，则禁用
          return timeYear < currentYear || (timeYear === currentYear && timeMonth < currentMonth);
        }
      },
      rules: {
        projectId: [{ required: true, message: '请选择培训科目', trigger: 'change' }],
        realName: [
          { required: true, message: '请输入用户姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        cardNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度在 18 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
        ],
        degree: [{ required: true, message: '请选择学历', trigger: 'change' }],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度必须大于2个字符', trigger: 'blur' }
        ],
        desiredTrainDate: [{ required: true, message: '请选择参加面授班培训日期', trigger: 'change' }]
      },
      fileList: [],
      uploadUrl: window.glob.baseURL + '/common/upload', // 上传的图片服务器地址
      headers: {},
      keyFag: 123,
      keyFag1: 234,
      keyFag2: 567,
      keyFag3: 9023,
      keyFag4: 21321,
      academicList: [], //学历
      configVos: [], //线下班级
      isChu: true, //是否是初培
      subjectList: [], //培训科目
      textList: [], //动态表格
      imgList: [], //上传框
      s1Tab: 0,
      sysEnrollmentConfigs: [], //输入框的动态list
      upImgsList: [], //上传图片的list
      imgKey: 10084,
      formRules: {} // xs
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    initRules() {
      // 清空旧校验，刷新规则
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.textList.forEach(item => {
        if (item.isRequired === '01') {
          this.rules[item.id] = [
            {
              required: true,
              message: `请输入${item.fieldName}`,
              trigger: 'blur'
            }
          ];
        }
      });
      console.log(this.rules, 'this.rules');
    },
    goBack() {
      this.$router.back();
    },
    //
    handLand() {
      this.$forceUpdate();
    },
    handlForm(item, index) {
      console.log(item);
      this.form.configId = item.configId;
      this.s1Tab = index;
    },
    //提交报名
    submitForm() {
      console.log(this.form);
      let falg = false;
      this.imgList.forEach(v => {
        if (v.isRequired == '01') {
          console.log(v.imgUrl);

          if (v.imgUrl == '' || v.imgUrl == undefined) {
            falg = true;
            return false;
          }
        }
      });
      if (falg) {
        this.$message.error('资料未填写完全，请检查上传信息！');
        return false;
      }
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          // if (this.form.idPhoto == '' || this.form.idPhoto == undefined) {
          //   this.$message('请上传证件照！');
          //   return false;
          // }
          // if (this.form.idCardFrontImage == '' || this.form.idCardFrontImage == undefined) {
          //   this.$message('请上传身份证人像面！');
          //   return false;
          // }
          // if (this.form.idCardBackImage == '' || this.form.idCardBackImage == undefined) {
          //   this.$message('请上传身份证国徽面！');
          //   return false;
          // }
          // if (this.form.diploma == '' || this.form.diploma == undefined) {
          //   this.$message('请上传学历证明或电子证书！');
          //   return false;
          // }
          // if (!this.isChu) {
          //   if (this.form.operatingLicense == '' || this.form.operatingLicense == undefined) {
          //     this.$message('请上传操作证正面！');
          //     return false;
          //   }
          // }
          const sysEnrollmentUserApplyVos = {};
          for (const [key, value] of Object.entries(this.form)) {
            if (key.length == 32) {
              sysEnrollmentUserApplyVos[key] = value;
            }
          }

          this.form.sysEnrollmentUserApplyVos = sysEnrollmentUserApplyVos;
          if (Array.isArray(this.form.projectId)) {
            this.form.projectId = this.form.projectId[this.form.projectId.length - 1];
          }
          toGenerateOrder(this.form).then(res => {
            if (res.data.data.code == '1') {
              this.$router.push({
                path: '/toPayOrder',
                query: {
                  orderId: res.data.data.orderId
                }
              });
            }else {
              this.$message.error(res.data.data.msg)
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取学历
    getEducationList() {
      getEducationList().then(res => {
        console.log(res.data.data);
        this.academicList = res.data.data;
      });
    },
    //选中培训科目查询线下班级
    handlChange() {
      console.log(this.form.projectId[this.form.projectId.length - 1]);
      // 方法1：通过ref获取选中节点的标签
      const checkedNodes = this.$refs.projectCascader.getCheckedNodes();
      if (checkedNodes && checkedNodes.length > 0) {
        const selectedNode = checkedNodes[0];
        // 如果你需要节点原始数据
        const nodeData = selectedNode.data;
        if (nodeData?.codeName?.includes('复')) {
          this.isChu = false;
        } else {
          this.isChu = true;
        }
      }
      this.getClassListBySubject(this.form.projectId[this.form.projectId.length - 1]);
      setTimeout(() => {
        this.initRules();
      }, 500);
    },
    //查询线下班级和是否购买过
    getClassListBySubject(id) {
      getClassListBySubject({ subjectId: id, configId: this.$route.query.parentId }).then(res => {
        if (res.data.code == '500') {
          this.$confirm(res.data.msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // on close
              this.$router.go(-1);
            })
            .catch(() => {
              this.$router.go(-1);
            });
        } else {
          this.textList = []; //动态输入框
          this.imgList = []; //上传图片框
          res.data.data.sysEnrollmentConfigs.forEach(v => {
            if (v.fieldType == 'image') {
              this.imgList.push(v);
            } else {
              this.textList.push(v);
            }
          });
          this.sysEnrollmentConfigs = res.data.data.sysEnrollmentConfigs;
          this.form.onlineClassId = res.data.data.onlineClassList.id;
          this.configVos = res.data.data.configVos;
          this.form.configId = res.data.data.configVos[0].configId || '';
          this.form.offlineClassId = res.data.data.configVos[0].offlineClassId || '';
        }
      });
    },

    //获取培训科目
    codeListByParent() {
      codeListByParent({ parentId: this.$route.query.trainIndustry }).then(res => {
        this.subjectList = res.data.data.list;
        //判断从搜索过来是不是最后一级
        this.form = res.data.data.user;
        if (res.data.data.codeVo) {
          
          this.form.codeName = res.data.data.codeVo.codeName;
          if (this.form.codeName.charAt(this.form.length - 2) == '复') {
            this.isChu = false;
          } else {
            this.isChu = true;
          }
          this.getClassListBySubject(res.data.data.codeVo.id);
          this.form.projectId = res.data.data.codeVo.cid;
          let data = {
            codeName: res.data.data.codeVo.codeName,
            cid: res.data.data.codeVo.cid
          };
          this.subjectList = [data];
        }
        this.form.realName = res.data.data.user.realName;
        this.form.cardNo = res.data.data.user.cardNo;
        this.form.mobile = res.data.data.user.mobile;
        this.form.degree = res.data.data.user.degree;
        this.form.companyName = res.data.data.user.organization;
        this.form.idPhoto = res.data.data.user.userPhoto;
        this.form.codeName = this.$route.query.codeName;
      });
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG = file.type === 'image/jpeg';
      const iPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (isJPG || iPNG) {
      } else {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || iPNG) && isLt2M;
    },
    handleAvatarSuccess(res, file) {
      console.log(res.url, file);
      this.form.idPhoto = res.url;
      this.keyFag = this.keyFag + 1;
    },
    handleAvatarSuccess1(res, file) {
      console.log(res.url, file);
      this.form.idCardFrontImage = res.url;
      this.keyFag1 = this.keyFag + 1;
    },
    handleAvatarSuccessALL(response, file, fileList, item) {
      console.log(response, file, fileList, item);
      item.imgUrl = response.url;
      this.imgKey = this.imgKey + 1;
      this.form[item.id] = response.url;
    },
    handleAvatarSuccess2(res, file) {
      console.log(res.url, file);
      this.form.idCardBackImage = res.url;
      this.keyFag2 = this.keyFag + 1;
    },
    handleAvatarSuccess3(res, file) {
      console.log(res.url, file);
      this.form.diploma = res.url;
      this.keyFag3 = this.keyFag + 1;
    },
    handleAvatarSuccess4(res, file) {
      console.log(res.url, file);
      this.form.operatingLicense = res.url;
      this.keyFag4 = this.keyFag + 1;
    },
    getToken() {
      this.headers = {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      };
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getEducationList();
    this.codeListByParent();

    this.getToken();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.up {
  font-size: 16px;
  position: relative;
  margin-right: 100px;
  .tips {
    position: absolute;
    right: 0px;
    transform: translateX(-50%);
    bottom: -20px;
    color: #f56c6c;
    font-size: 12px;
  }
  .upImg {
    margin-top: 13px;
    display: flex;
    .up1 {
      cursor: pointer;
      width: 120px;
      height: 168px;
      background: #f4f6fa;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #efefef;
      display: flex;
      justify-content: center;
      align-items: center;
      .idImg {
        width: 120px;
        height: 168px;
      }
    }
    .up2 {
      margin-left: 30px;
      width: 240px;
      font-size: 14px;
      color: #666;
    }
  }
  .c1 {
    margin-top: 13px;
    cursor: pointer;
    width: 237px;
    height: 140px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .upBtn {
    padding: 0 !important;
    margin-top: 12px;
    cursor: pointer;
    width: 92px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #3172f6;
    color: #3172f6;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
  }
  .c2 {
    margin-top: 13px;
    cursor: pointer;
    width: 237px;
    height: 140px;
    background: #f8f9fb;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #efefef;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sxbBox {
    display: flex;
    flex-wrap: wrap;
    margin-top: 13px;
    .s1 {
      width: 420px;
      height: 90px;
      background: #f4f6fa;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      padding: 20px 20px 20px 34px;
      margin-right: 40px;
      cursor: pointer;
      .yuan {
        width: 20px;
        height: 20px;
        background: #3172f6;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
      }

      .noYuan {
        width: 20px;
        height: 20px;
        border: 1px solid #979797;
        border-radius: 50%;
        line-height: 20px;
        text-align: center;
      }
    }
    .yActive {
      background: rgba(49, 114, 246, 0.1) !important;
      border: 1px solid #3172f6;
    }
    .s2 {
      margin-left: 20px;
      font-size: 16px;
      .s3 {
        color: #888888;
      }
    }
  }
}
.up:nth-child(4n) {
  margin-right: 0 !important;
}
/deep/ .el-form-item__label {
  font-size: 16px !important;
}
.allImage {
  width: 237px;
  height: 140px;
}
.banner {
  background: #f4f6fa;
  padding: 16px 0 170px 0;
  .subBox {
    margin: 0 auto;
    width: 1400px;
    background: #ffffff;
    background: #fff;
    padding: 24px 20px;
    .subTitle {
      display: flex;
      justify-content: space-between;
      .s1 {
        display: flex;
        color: #999999;
        font-size: 16px;
        cursor: pointer;
      }
      .s2 {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
      }
      .s3 {
        font-weight: 400;
        font-size: 14px;
        color: #ff0000;
      }
    }
  }

  .formBox {
    margin-top: 45px;
    .xu {
      border-bottom: 1px dashed #d4d6db;
    }
    .updataBox {
      padding-top: 40px;
      .up {
        font-size: 16px;
        position: relative;
        .tips {
          position: absolute;
          right: 0px;
          transform: translateX(-50%);
          bottom: -20px;
          color: #f56c6c;
          font-size: 12px;
        }
        .upImg {
          margin-top: 13px;
          display: flex;
          .up1 {
            cursor: pointer;
            width: 120px;
            height: 168px;
            background: #f4f6fa;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #efefef;
            display: flex;
            justify-content: center;
            align-items: center;
            .idImg {
              width: 120px;
              height: 168px;
            }
          }
          .up2 {
            margin-left: 30px;
            width: 240px;
            font-size: 14px;
            color: #666;
          }
        }
        .c1 {
          margin-top: 13px;
          cursor: pointer;
          width: 237px;
          height: 140px;
          background: #f4f6fa;
          border-radius: 4px 4px 4px 4px;
        }
        .upBtn {
          padding: 0 !important;
          margin-top: 12px;
          cursor: pointer;
          width: 92px;
          height: 32px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #3172f6;
          color: #3172f6;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
        }
        .c2 {
          margin-top: 13px;
          cursor: pointer;
          width: 237px;
          height: 140px;
          background: #f8f9fb;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #efefef;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .sxbBox {
          display: flex;
          flex-wrap: wrap;
          margin-top: 13px;
          .s1 {
            width: 420px;
            height: 90px;
            background: #f4f6fa;
            border-radius: 4px 4px 4px 4px;
            display: flex;
            align-items: center;
            padding: 20px 20px 20px 34px;
            margin-right: 40px;
            cursor: pointer;
            .yuan {
              width: 20px;
              height: 20px;
              background: #3172f6;
              border-radius: 50%;
              line-height: 20px;
              text-align: center;
            }

            .noYuan {
              width: 20px;
              height: 20px;
              border: 1px solid #979797;
              border-radius: 50%;
              line-height: 20px;
              text-align: center;
            }
          }
          .yActive {
            background: rgba(49, 114, 246, 0.1) !important;
            border: 1px solid #3172f6;
          }
          .s2 {
            margin-left: 20px;
            font-size: 16px;
            .s3 {
              color: #888888;
            }
          }
        }
      }
    }
    .subBtn {
      cursor: pointer;
      margin: 60px auto auto auto;
      width: 180px;
      height: 48px;
      background: #3172f6;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #3172f6;
      color: #fff;
      text-align: center;
      line-height: 48px;
      font-size: 16px;
    }
  }
}
</style>
